import Vue from 'vue';
import channels from './channels'

export default {
  log_in(context, {email, password}) {
    return new Promise((resolve, reject) => {
      Vue.http.post("login", JSON.stringify({email: email.toLowerCase(), password: password})).then((response) => {
        if (response.body.status == "ok") {
          localStorage.setItem("token", response.body.result);
          Vue.http.headers.common['Authorization'] = response.body.result;
          context.dispatch("logged_in");
          context.state.logged_in = true;
          resolve();
        } else {
          reject({msg: "Invalid email or password", response: response});
        }
      },
      (response) => {
        console.log(response);
        reject({msg: "Cannot login, please try again later", response: response})
      });
    })
  },
  logged_in(context) {
    Vue.Socket.connect( {token: localStorage.getItem("token")} );
    channels.join_all(context);
  },
  get_profile(context) {
    return new Promise((resolve, reject) => {
      context.state.ws_channels.profile.push("get", {}, 10000)
        .receive("ok", (msg) => {
          //console.log("Get profile", msg.account);
          context.commit("set_profile", msg);
          resolve();
        })
        .receive("error", (reasons) => {
          console.log("Profile get failed", reasons)
          reject();
        })
        .receive("timeout", () => {
          console.log("Networking issue...")
          reject();
        })
    });
  },
  update_profile(context, payload) {
    return new Promise((resolve, reject) => {
      context.state.ws_channels.profile.push("update", payload, 10000)
        .receive("ok", (msg) => {
          context.dispatch("get_profile");
          resolve(msg);
        })
        .receive("error", (msg) => {
          msg.type = "error";
          reject(msg)
        })
        .receive("timeout", () => {
          console.log("Networking issue...")
          reject({type: "network_issue", msg: "Networking issue..."});
        })
    });
  },
  change_password(context, payload) {
    return new Promise((resolve, reject) => {
      context.state.ws_channels.profile.push("change_password", payload, 10000)
        .receive("ok", (msg) => {
          resolve(msg);
        })
        .receive("error", (msg) => {
          msg.type = "error";
          reject(msg)
        })
        .receive("timeout", () => {
          console.log("Networking issue...")
          reject({type: "network_issue", msg: "Networking issue..."});
        })
    });
  },
  log_out(context) {
    return new Promise((resolve, reject) => {
      Vue.http.get("logout").then((response) => {
        context.dispatch("logged_out");
        resolve();
      }, (response) => {
        reject({msg: "Cannot logout, try again later", response: response})
      });
    });
  },
  logged_out(context) {
    Vue.Socket.disconnect();
    localStorage.removeItem("token");
    context.commit("logged_in", false);
    context.commit("clear");
  },
  send_control(context, data) {
    return new Promise((resolve, reject) => {
      var msg_type = data.type;
      var msg_payload = data.payload;
      context.state.ws_channels["control"].push(msg_type, msg_payload)
        .receive("ok", (msg) => {
          resolve(msg);
        })
        .receive("error", (msg) => {
          reject(msg);
        });
    });
  },
 
}
